import { render, staticRenderFns } from "./UsefulTitle.vue?vue&type=template&id=64d2d394&scoped=true&"
import script from "./UsefulTitle.vue?vue&type=script&lang=js&"
export * from "./UsefulTitle.vue?vue&type=script&lang=js&"
import style0 from "./UsefulTitle.vue?vue&type=style&index=0&id=64d2d394&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d2d394",
  null
  
)

export default component.exports